import NewReport from './NewReportContainer';

export default NewReport;



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/new-report/index.js